import { toast } from 'react-toastify';
import { clearCache } from './apiCache';

let handleSessionExpired = null;

export const setSessionExpiredHandler = (handler) => {
    handleSessionExpired = handler;
};

// Extrae un mensaje legible del cuerpo de una respuesta de error.
// Prioriza `message`; usa `error` solo si es texto humano (no un código
// tipo FORBIDDEN / NEED_SESSION).
const extraerMensaje = (data, porDefecto) => {
    if (data?.message) return data.message;
    if (typeof data?.error === 'string' && !/^[A-Z_]+$/.test(data.error)) {
        return data.error;
    }
    return porDefecto;
};

export const handleAuthError = (error) => {
    const status = error.response && error.response.status;

    if (status === 401) {
        // Solo el 401 significa problema de sesión/autenticación: se expulsa.
        console.log("Sesión expirada. Cerrando sesión...");

        localStorage.removeItem("token");
        localStorage.removeItem("lastActivity");
        localStorage.removeItem("numActivo");
        clearCache();

        if (handleSessionExpired) {
            handleSessionExpired();
        }
    } else if (status === 403) {
        // 403 = autenticado pero sin permiso. No se expulsa: solo se avisa.
        const mensaje = extraerMensaje(
            error.response.data,
            "No tienes permiso para esta acción"
        );
        toast.error(mensaje);
    }

    console.log("Ha habido un error:", error);
    throw error;
};